export const DEFAULT_BEHAVIOR = "click";
